import { useAppSelector } from "@/Hook/hooks";
import { ControlTranslation } from "AlignComponents";
import { Col, Row } from "react-bootstrap";
import Attendance from "./Attendance";
import Employee from "./Employee";
import EmployeeSelector from "./EmployeeSelector";
import HelloIcon from "./HelloIcon";
import MyTeam from "./MyTeam";
import MyBalance from "./MyBalance";

const SelfService = () => {
  const user = useAppSelector(x => x.User.user);

  return (
    <div className="widget self-service">
      <div className="self-service-header">
        <ControlTranslation system={true} controlId="lblwelcome" />, {user.name} <HelloIcon />

        {
          user.peoplenestadmin ? (
            <div className="ms-auto">
              <EmployeeSelector />
            </div>
          ) : null
        }
      </div>
      <Row>
        <Col md={7}>
          <Employee />
        </Col>
        <Col md={5}>
          <Attendance />
        </Col>
        <Col md={12} className="mt-2">
          <MyTeam />
        </Col>
        <Col md={12} className="mt-2">
          <MyBalance />
        </Col>
      </Row>
    </div >
  )
};

export default SelfService;